import { AttributeType } from "../../../../../api/types"
import {
  ObjectValidatorsMap,
  ObjectMapValidator,
  rangeCharactersValidator
} from "../../../../../components/Validator"

const AttributeTypeValidatorMap: ObjectValidatorsMap<AttributeType> = {
  name: rangeCharactersValidator(
    0,
    100,
    "Attribute type name is required with a max length of 100 characters."
  ),
  description: rangeCharactersValidator(
    -1,
    250,
    "The description has a maximum length of 250 characters."
  )
}

const AttributeTypeValidator = new ObjectMapValidator<AttributeType>(
  AttributeTypeValidatorMap
)

export default AttributeTypeValidator
